export default __webpack_public_path__ + "static/media/Icon=Task Priority.f28d840a.svg";